import React, {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {clearSession, getCookie} from '../api';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  const tenantName = getCookie('tenantName') ? decodeURIComponent(getCookie('tenantName')) : 'HCM Central';
  const displayName = getCookie('displayName') ? decodeURIComponent(getCookie('displayName')) : '';

  const linkClass = (path) =>
    `flex items-center px-6 py-3 ${
      pathname === path || (path !== '/' && pathname.startsWith(path))
        ? 'bg-indigo-600 text-white'
        : 'text-gray-700 hover:bg-gray-100'
    }`;

  const handleLogout = () => {
    clearSession();
    window.location.href = '/login';
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <aside className={`w-64 bg-white border-r border-gray-200 h-screen fixed left-0 top-0 z-30 transition-transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0`}>
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-lg font-bold text-gray-900">{tenantName}</h2>
        </div>
        <nav className="mt-6">
          <Link to="/" className={linkClass('/')} onClick={() => setSidebarOpen(false)}>
            <span>Home</span>
          </Link>
          <Link to="/courses" className={linkClass('/courses')} onClick={() => setSidebarOpen(false)}>
            <span>My Courses</span>
          </Link>
          <Link to="/documents" className={linkClass('/documents')} onClick={() => setSidebarOpen(false)}>
            <span>My Documents</span>
          </Link>
          <Link to="/timesheets" className={linkClass('/timesheets')} onClick={() => setSidebarOpen(false)}>
            <span>Timesheets</span>
          </Link>
          <Link to="/credentials" className={linkClass('/credentials')} onClick={() => setSidebarOpen(false)}>
            <span>My Credentials</span>
          </Link>
          <Link to="/profile" className={linkClass('/profile')} onClick={() => setSidebarOpen(false)}>
            <span>My Profile</span>
          </Link>
          <Link to="/time-off" className={linkClass('/time-off')} onClick={() => setSidebarOpen(false)}>
            <span>Time Off</span>
          </Link>
          <Link to="/notifications" className={linkClass('/notifications')} onClick={() => setSidebarOpen(false)}>
            <span>Notifications</span>
          </Link>
          <Link to="/policies" className={linkClass('/policies')} onClick={() => setSidebarOpen(false)}>
            <span>Policies</span>
          </Link>
          <Link to="/feed" className={linkClass('/feed')} onClick={() => setSidebarOpen(false)}>
            <span>Feed</span>
          </Link>
          <Link to="/benefits" className={linkClass('/benefits')} onClick={() => setSidebarOpen(false)}>
            <span>Benefits</span>
          </Link>
          <Link to="/expenses" className={linkClass('/expenses')} onClick={() => setSidebarOpen(false)}>
            <span>Expenses</span>
          </Link>
          <Link to="/goals" className={linkClass('/goals')} onClick={() => setSidebarOpen(false)}>
            <span>Goals</span>
          </Link>
          <Link to="/team-calendar" className={linkClass('/team-calendar')} onClick={() => setSidebarOpen(false)}>
            <span>Team Calendar</span>
          </Link>
          <Link to="/pay-history" className={linkClass('/pay-history')} onClick={() => setSidebarOpen(false)}>
            <span>Pay History</span>
          </Link>
        </nav>
      </aside>

      <header className="bg-white shadow-sm h-16 fixed top-0 right-0 left-0 md:left-64 z-10">
        <div className="flex items-center justify-between h-full px-6">
          <button onClick={() => setSidebarOpen(true)} className="md:hidden text-gray-600 hover:text-gray-900">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <div />
          <div className="flex items-center gap-4">
            {displayName && <span className="text-sm text-gray-600">{displayName}</span>}
            <button onClick={handleLogout} className="text-sm text-gray-600 hover:text-red-600 font-medium">Sign Out</button>
          </div>
        </div>
      </header>

      <main className="md:ml-64 pt-16">
        <div className="p-4 md:p-6">
          {children}
        </div>
      </main>
    </div>
  );
}
